var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeAcademyThruster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.4 73.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5757ce;}.cls-2{fill:#4e4ea0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.4 60.57 74.31 73.8 74.31 0 113.4 13.23 113.4 60.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.31 73.8 0 42.48 0 31.31 74.31 0 74.31 73.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeAcademyThruster);
export default __webpack_public_path__ + "static/media/upgrade-academy-thruster.3ce2254ca4bc7ebe51f089499ccdf79e.svg";
export { ForwardRef as ReactComponent };